import { INews } from 'models/News/INews'
import { TranslationKeys } from 'types/TranslationKeys'
import getLanguageFromUrl from 'utils/getLanguageFromUrl'

export interface ListProps {
  news: INews[] | null
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useList = (props: ListProps) => {
  const selectedLanguage = getLanguageFromUrl()

  return {
    ...props,
    selectedLanguage,
  }
}
